import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { ClearAllSvg } from './svgs';

export const IconClearAll: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={ClearAllSvg} viewBox="0 0 16 16" {...props} />;
};
